import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { CookiesProvider } from 'react-cookie'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { RecoilRoot } from 'recoil'
import { ProSidebarProvider } from 'react-pro-sidebar'

createRoot(document.getElementById('root')).render(
  <RecoilRoot>
    <CookiesProvider>
      <ProSidebarProvider>
        <App />
      </ProSidebarProvider>
    </CookiesProvider>
  </RecoilRoot>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
